import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { ProductTypeVariant } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeVariantService extends TmsWebBaseEditCreateService<ProductTypeVariant, ProductTypeVariant> {
  constructor() {
    super('ProductTypeVariant', $localize`Product Type Variant`);
  }

  getByProductType(productTypeId: string): Observable<ProductTypeVariant[]> {
    return this.httpService.get<ProductTypeVariant[]>(`${this.apiUrl}/ProductType/${productTypeId}`);
  }

  getForProductType(productTypeId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProductType/${productTypeId}`);
  }
}
